<template>
  <div class="home">
    <div class="header">Manage your clips by streams</div>
    <template v-if="streamsLoaded && clipsLoaded">
      <div v-if="streamsLoaded && currentStream" class="current-stream">
        <button
          :disabled="arrowRightDisabled"
          class="nav"
          @click="goPreviousStream"
        >
          <icon icon="chevron-left" />
        </button>
        <div class="stream-info">
          <div class="stream-title">{{ currentStream.title }}</div>
          <div class="stream-date">{{ formattedDate }}</div>
          <button class="button" @click="downloadAllFromStream">
            download all
          </button>
        </div>
        <button :disabled="arrowLeftDisabled" @click="goNextStream" class="nav">
          <icon icon="chevron-right" />
        </button>
      </div>
      <div v-else-if="streamsLoaded && !currentStream">
        You do have have any past stream available
      </div>
      <div
        v-if="streamsLoaded && clipsLoaded && currentStream"
        class="clips-container"
      >
        <template v-if="currentClips.clips.length > 0">
          <div v-for="clip in currentClips.clips" :key="clip.id" class="clip">
            <div class="img-container">
              <img :src="clip.thumbnail_url" alt="thumbnail" />
            </div>
            <div class="clip-details">
              <div class="title">{{ clip.title }}</div>
              <div class="views">{{ clip.view_count }} views</div>
              <div class="creator">by {{ clip.creator_name }}</div>
            </div>
            <div class="buttons">
              <button @click="onViewClick($event, clip.embed_url)">
                <icon icon="eye" />
              </button>
              <a target="_blank" :href="clip.url">
                <icon icon="edit" />
              </a>
              <a
                target="_blank"
                :href="
                  clip.thumbnail_url.replace('-preview-480x272.jpg', '') +
                    '.mp4'
                "
                download
              >
                <icon icon="download" />
              </a>
              <button
                @click="twitterShare(clip.url, clip.title)"
                :href="clip.url"
              >
                <icon :icon="['fab', 'twitter']" />
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          You don't have clips for this vod
        </template>
      </div>
    </template>
    <div v-else class="loading">
      <Loading />
    </div>
    <div class="modal" v-if="embedToDisplay" @click="onModalClick">
      <iframe :src="embedToDisplay" width="500" height="281" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TOKEN_ITEM, CLIENT_ID } from "../settings";
import { format } from "date-fns";
import Loading from "../components/Loading";

export default {
  name: "home",
  components: { Loading },
  data() {
    return {
      streams: [],
      currentStream: null,
      totalClipsCollected: 0,
      clips: [],
      embedToDisplay: "",
      clipsLoaded: false,
      streamsLoaded: false
    };
  },
  props: {
    user: {
      type: String,
      required: true
    }
  },
  methods: {
    downloadAllFromStream() {
      this.currentClips.clips.forEach((clip, index) => {
        setTimeout(() => {
          const url =
            clip.thumbnail_url.replace("-preview-480x272.jpg", "") + ".mp4";
          const a = document.createElement("A");
          a.href = url;
          a.setAttribute("download", "");
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }, index * 500 + 10);
      });
    },
    twitterShare(url, title) {
      window.open(`https://twitter.com/intent/tweet?text=${title}&url=${url}`);
    },

    goNextStream() {
      const i = this.streams.findIndex(
        stream => stream.id === this.currentStream.id
      );
      let stream = this.streams[i + 1];

      while (!this.clipsByStreams[stream.id]) {
        const j = this.streams.findIndex(s => s.id === stream.id);
        stream = this.streams[j + 1];
      }

      this.currentStream = stream;
    },
    goPreviousStream() {
      const i = this.streams.findIndex(
        stream => stream.id === this.currentStream.id
      );
      let stream = this.streams[i - 1];

      while (!this.clipsByStreams[stream.id]) {
        const j = this.streams.findIndex(s => s.id === stream.id);
        stream = this.streams[j - 1];
      }

      this.currentStream = stream;
    },
    onModalClick() {
      this.embedToDisplay = "";
    },
    onViewClick(event, embedUrl) {
      event.preventDefault();
      event.stopPropagation();
      this.embedToDisplay = embedUrl;
    },
    async getStreams(cursor) {
      return axios
        .get(`https://api.twitch.tv/helix/videos`, {
          headers: {
            "Client-ID": CLIENT_ID,
            Authorization: `Bearer ${localStorage.getItem(TOKEN_ITEM)}`
          },
          params: {
            user_id: this.user,
            period: "all",
            first: "100",
            type: "archive",
            after: cursor
          }
        })
        .then(response => {
          if (
            response.data.pagination &&
            response.data.pagination.cursor &&
            response.data.pagination.cursor !== "IA"
          ) {
            return [
              ...response.data.data,
              this.getStreams(response.data.pagination.cursor)
            ];
          } else {
            return response.data.data;
          }
        });
    },
    async getAllClips() {
      let isFinished = false;
      let cursor = "";
      let res = [];
      while (!isFinished) {
        const response = await axios.get(`https://api.twitch.tv/helix/clips`, {
          headers: {
            "Client-ID": CLIENT_ID,
            Authorization: `Bearer ${localStorage.getItem(TOKEN_ITEM)}`
          },
          params: {
            broadcaster_id: this.user,
            first: "100",
            after: cursor
          }
        });
        if (
          response.data.pagination &&
          response.data.pagination.cursor &&
          response.data.pagination.cursor !== "IA"
        ) {
          cursor = response.data.pagination.cursor;
        } else {
          isFinished = true;
        }
        this.totalClipsCollected =
          this.totalClipsCollected + response.data.data.length;
        res = [...res, ...response.data.data];
      }
      return res;
    }
  },
  computed: {
    arrowRightDisabled() {
      return (
        this.streams.length === 0 ||
        this.streams.findIndex(
          stream => stream.id === this.currentStream.id
        ) === 0
      );
    },
    arrowLeftDisabled() {
      return (
        this.streams.length === 0 ||
        this.streams.findIndex(
          stream => stream.id === this.currentStream.id
        ) ===
          this.streams.length - 1
      );
    },
    formattedDate() {
      const date = new Date(this.currentStream.created_at);
      return format(date, "do MMMM y");
    },
    clipsOrigin() {
      return this.clips
        .reduce((reducer, item) => {
          const origin = item.video_id;
          if (!reducer.includes(origin) && origin) {
            reducer.push(origin);
          }
          return reducer;
        }, [])
        .filter(originId =>
          this.streams.find(stream => {
            return stream.id === originId;
          })
        );
    },
    clipsByStreams() {
      return this.clipsOrigin.reduce((reducer, originId) => {
        reducer[originId] = {
          stream: this.streams.find(stream => stream.id === originId),
          clips: this.clips.filter(clip => clip.video_id === originId) || []
        };
        return reducer;
      }, {});
    },
    currentClips() {
      if (!this.currentStream) return null;
      return (
        this.clipsByStreams[this.currentStream.id] || {
          stream: this.currentStream,
          clips: []
        }
      );
    }
  },
  mounted() {
    Promise.all([
      this.getStreams().then(streams => {
        this.streams = streams;
        return streams;
      }),
      this.getAllClips().then(clips => {
        this.clips = clips;
      })
    ]).then(([streams]) => {
      let i = 0;
      let stream = streams[0];
      if (stream) {
        while (stream && !this.clipsByStreams[stream.id]) {
          i = i + 1;
          stream = streams[i];
        }

        this.currentStream = stream;
      }
      this.streamsLoaded = true;

      this.clipsLoaded = true;
    });
  }
};
</script>

<style scoped lang="scss">
.clips-container {
  @apply px-4;

  .clip {
    @apply flex my-2  bg-gray-200;

    .img-container {
      width: 10rem;
      user-select: none;
      @apply mr-2 inline-flex justify-center items-center;
    }

    .clip-details {
      @apply py-1 flex-1;
      .title {
        @apply font-semibold text-lg;
      }
      .views {
        @apply text-sm;
      }
      .creator {
        @apply text-sm opacity-50;
      }
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.buttons {
  display: flex;
  flex-direction: column;
  @apply m-2;
}

.header {
  @apply p-4 font-bold text-xl text-center;
}

.current-stream {
  @apply flex px-12;
  .stream-info {
    @apply flex-1 text-center;
    .stream-title {
      @apply font-semibold;
    }
    .stream-date {
      @apply text-sm;
    }
  }
  .nav {
    &:disabled {
      @apply opacity-50;
    }
  }
}

.loading {
  text-align: center;
}

.button {
  @apply px-4 py-2 bg-purple-500 text-white font-semibold rounded-md inline-flex mt-2;
}
</style>
